<template>
    <section class="url-upload-header">
      <input
        type="text"
        class="library-search-bar-input url-input"
        :placeholder="$t('EMBED_CODE')"
        v-model="embeddedUrl"
        @keyup.enter="updateEmbeddedCode"
        @blur="updateEmbeddedCode"
        ref="url"
      />
      <span class="error-text">{{ $t("ERROR_TEXT") }}</span>
    </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'embedded-audio-upload-header',

  data () {
    return {
      embeddedUrl: null
    }
  },

  created () {
    this.$nextTick(function () {
      this.$refs.url.focus()
    })
    if (this.selectedEntryOrigin === 'collectionEntry') {
      this.embeddedUrl = this.selectedEntry.object.url
    }
  },

  computed: {
    ...mapState({
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      selectedEntry: state => state.collections.selectedEntry
    })
  },

  methods: {
    updateEmbeddedCode () {
      if (!this.embeddedUrl) return
      // If the user enter embedded-code,
      // Get only the src of the iframe.
      if (this.embeddedUrl.indexOf('iframe') > -1) {
        this.embeddedUrl = this.embeddedUrl.split('src=')[1].split('"')[1]
      } else if (!(this.embeddedUrl.indexOf('embed') > -1)) {
        // If the user enter link without `embed`
        // Replace it with an embedded link.
        let url = null
        let urlSplitArray = this.embeddedUrl.split('//')
        // Get the started path
        url = urlSplitArray[0] + '//'
        urlSplitArray = urlSplitArray[1].split('/')
        // Add host-name and `embed` to the path
        url += urlSplitArray[0] + '/embed'
        // Add the continuation of the path
        urlSplitArray.splice(0, 1)
        for (const u of urlSplitArray) {
          url += '/' + u
        }
        this.embeddedUrl = url
      }
      this.$store.dispatch('setUploadUrl', this.embeddedUrl)
    }
  }
}
</script>

<style scoped>

</style>
